/** Horizontal bar chart for top visitor countries — CSS-based, consistent with
 *  the site's design language (no heavy chart lib dependency for this panel). */

function flag(code) {
  if (!code || code.length !== 2) return "";
  const base = 0x1f1e6 - 65;
  return (
    String.fromCodePoint(base + code.toUpperCase().charCodeAt(0)) +
    String.fromCodePoint(base + code.toUpperCase().charCodeAt(1))
  );
}

export function CountryBreakdownChart({ countries }) {
  if (!countries?.length) return null;

  const top = countries.slice(0, 8);
  const max = Math.max(1, ...top.map((c) => c.count));
  const total = countries.reduce((s, c) => s + c.count, 0);

  return (
    <div data-testid="country-breakdown-chart" className="px-6 py-4">
      <div className="text-[0.65rem] tracking-[0.28em] uppercase text-[#5C6670] mb-4">
        Visitor breakdown by country
      </div>
      <ul className="space-y-2.5">
        {top.map((c, i) => {
          const pct = Math.max(4, Math.round((c.count / max) * 100));
          const f = flag(c.country_code);
          return (
            <li key={c.country + i} className="flex items-center gap-3" data-testid={`country-bar-${i}`}>
              {/* Rank + flag + name */}
              <span className="w-5 text-[0.6rem] tabular-nums text-[#B8BCC2] text-right shrink-0">
                {i + 1}
              </span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs text-[#1A1F24] truncate">
                    {f && <span className="mr-1.5">{f}</span>}
                    {c.country || c.country_code || "Unknown"}
                  </span>
                  <span className="text-xs tabular-nums text-[#C5A059] ml-2 shrink-0">{c.count}</span>
                </div>
                {/* Bar */}
                <div className="h-1.5 bg-[#F0F0F0] rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full transition-all duration-500"
                    style={{
                      width: `${pct}%`,
                      backgroundColor: i === 0 ? "#C5A059" : `rgba(197,160,89,${Math.max(0.22, 0.85 - i * 0.09)})`,
                    }}
                  />
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
